/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcome_Terms_HeadingInputs */

const en_welcome_terms_heading = /** @type {(inputs: Welcome_Terms_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms & Services`)
};

/**
* | output |
* | --- |
* | "Terms & Services" |
*
* @param {Welcome_Terms_HeadingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const welcome_terms_heading = /** @type {((inputs?: Welcome_Terms_HeadingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Terms_HeadingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_welcome_terms_heading(inputs)
});